function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event, false, false);
    }, 500);

    this.querySelector('form.apply-on__click')?.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.querySelector('form.apply-on__click')?.addEventListener('submit', (e) => this.onSubmitHandler(e, true, true));
    this.querySelector('form.apply-on__submit')?.addEventListener('submit', (e) => this.onSubmitHandler(e, false, true));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('ProductGridContainer').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');

    if (window.dAgency.proxyLinkSetup) window.dAgency.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.dAgency.ajaxinateCallBack(requestURL);
      }
    });

    if (typeof (window.dAgency) !== 'undefined' && typeof (window.dAgency.initProductTile) !== 'undefined') {
      document.getElementById('ProductGridContainer').querySelectorAll('.product-tile__container:not(.product-tile__container--initialized)').forEach(tile => {
        window.dAgency.initProductTile(tile);
      });
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static updateGeneralCounter() {
    const generalCounter = document.querySelector('.collection-header__filters-opener [active-filters-counter]');
    if (generalCounter) {
      let activeFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
      const filterPriceMin = document.querySelector('#Filter-price-min')?.value;
      const filterPriceMax = document.querySelector('#Filter-price-max')?.value;

      if (filterPriceMin || filterPriceMax) {
        activeFilters++;
      }

      generalCounter.innerText = `(${activeFilters})`;
      if (activeFilters <= 0) {
        generalCounter.style.display = 'none';
      } else {
        generalCounter.style.display = '';
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(checkbox => {
        const activeLabel = document.querySelector(`label.filters-drawer__active-filters__filter[for="${checkbox.id}"]`);

        checkbox.addEventListener('change', function () {
          if (activeLabel) {
            if (checkbox.checked) {
              activeLabel.style.display = '';
            } else {
              activeLabel.style.display = 'none';
            }
          }

          const filterContainer = checkbox.closest('[data-filter]');

          if (filterContainer) {
            const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
            const checkedCounters = filterContainer.querySelectorAll('input[type="checkbox"]:checked').length;
            if (counterLabels.length > 0) {
              counterLabels.forEach(counterLabel => {
                counterLabel.innerText = `(${checkedCounters})`;

                if (checkedCounters <= 0) {
                  counterLabel.style.display = 'none';
                } else {
                  counterLabel.style.display = '';
                }
              });
            }
          }
        });
      });
    });

    FacetFiltersForm.updateGeneralCounter();

    const activeFiltersCount = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked').length;
    const filterPriceMin = document.querySelector('#Filter-price-min')?.value;
    const filterPriceMax = document.querySelector('#Filter-price-max')?.value;

    document.querySelectorAll('#FacetFiltersForm facet-remove').forEach(removeButton => {
      if (activeFiltersCount <= 0 && !filterPriceMin && !filterPriceMax) {
        removeButton.style.display = 'none';
      } else {
        removeButton.style.display = '';
      }
    });
  }

  static updateURLHash(searchParams) {
    this.onSortingPrice(searchParams);

    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static onSortingPrice(searchParams) {
        document.querySelector('body').classList.remove('sort-price-asc', 'sort-price-desc');
        if (searchParams.includes('sort_by=price-ascending')) {
          document.querySelector('body').classList.add('sort-price-asc');
        }

        if (searchParams.includes('sort_by=price-descending')) {
          document.querySelector('body').classList.add('sort-price-desc');
        }
  }

  onSubmitHandler(event, simulateSubmit, closePanels) {
    event.preventDefault();

    if (!simulateSubmit) {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }

    if (closePanels) {
      // Close accordions except for price range, if set

      const filterPriceMin = document.querySelector('#Filter-price-min')?.value;
      const filterPriceMax = document.querySelector('#Filter-price-max')?.value;

      document.querySelectorAll('#FacetFiltersForm details[open]').forEach((el) => {
        if (!(el.parentNode.classList.contains('price_range') && (filterPriceMin || filterPriceMax))) {
          el.removeAttribute('open');
        }
      });
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    const range = this.querySelector('.filters-category__slider');
    const minInput = this.querySelector('#Filter-price-min');
    const maxInput = this.querySelector('#Filter-price-max');
    const rangeMin = typeof (this.dataset.min) !== 'undefined' ? parseInt(this.dataset.min) : 0;
    const rangeMax = typeof (this.dataset.max) !== 'undefined' ? parseInt(this.dataset.max) : 100000;
    const valueMin = minInput.value ? parseInt(parseFloat(minInput.value) * 100) : rangeMin;
    const valueMax = maxInput.value ? parseInt(parseFloat(maxInput.value) * 100) : rangeMax;
    const applyOnChange = document.querySelector('#FacetFiltersForm')?.classList.contains('apply-on__click');

    if (range && minInput && maxInput) {

      const minLabel = this.querySelector(`label[for="${minInput.id}"]`);
      const maxLabel = this.querySelector(`label[for="${maxInput.id}"]`);

      $(range).slider({
        range: true,
        min: rangeMin,
        max: rangeMax,
        values: [valueMin, valueMax],
        slide: (e, ui) => {
          var minValue = 0;
          if (ui.values[0] > 0) {
            minValue = Math.floor(ui.values[0] / 100);
          }
          minInput.value = minValue;
          if (minLabel) {
            minLabel.innerText = theme.Currency.formatMoney(minValue * 100, theme.strings.moneyFormat).split(',')[0];
          }

          var maxValue = rangeMax / 100;
          if (ui.values[1] < rangeMax) {
            maxValue = Math.ceil(ui.values[1] / 100);
          }
          maxInput.value = maxValue;
          if (maxLabel) {
            maxLabel.innerText = theme.Currency.formatMoney(maxValue * 100, theme.strings.moneyFormat).split(',')[0];
          }
        },
        change: (e) => {
          if (applyOnChange) {
            const formData = new FormData(e.target.closest('form'));
            const searchParams = new URLSearchParams(formData).toString();
            FacetFiltersForm.renderPage(searchParams, e);
          }
        }
      });
    }
    this.setMinAndMaxValues();
    FacetFiltersForm.updateGeneralCounter();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();

      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);

      document.querySelectorAll('#FacetFiltersForm details[open]').forEach((el) => {
        el.removeAttribute('open');
      });

      document.querySelectorAll('label.filters-drawer__active-filters__filter').forEach(activeFilter => {
        activeFilter.style.display = 'none';
        activeFilter.classList.remove('active');
      });

      document.querySelectorAll('[single-filter-active-counter], [active-filters-counter]').forEach(counter => {
        counter.innerText = '(0)';
        counter.style.display = 'none';
      });
    });
  }
}
customElements.define('facet-remove', FacetRemove);
